import React from 'react';
import PropTypes from 'prop-types';

import {Box, IconButton} from 'views/components';
import {CloseRounded, SearchRounded} from 'views/icons';
import {translate} from 'views/module';

const Search = (props) => {
  const {filterOptions, selection, updateFilter} = props;
  const searchFilter = filterOptions?.caregiverName;
  const selectedValue = selection?.filter?.caregiverName?.optionSelected || '';
  const [searchText, setSearchText] = React.useState(selectedValue);
  const inputRef = React.useRef(null);

  React.useEffect(() => {
    setSearchText(selectedValue);
  }, [selectedValue]);

  if (!searchFilter) return null;

  const updateSearch = (value) => {
    setSearchText(value);
    updateFilter(
        searchFilter,
        value.trim() ? {key: value, label: value} : null,
    );
  };

  const clearSearch = () => {
    updateSearch('');
    inputRef.current?.focus();
  };

  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        gap: 1,
        width: {xs: '100%', sm: 246},
        height: 32,
        px: 1.25,
        borderRadius: 4,
        backgroundColor: '#F0F0F0',
      }}
    >
      <SearchRounded sx={{fontSize: 18, color: '#7C7C7C'}} />
      <Box
        component="input"
        ref={inputRef}
        value={searchText}
        placeholder={translate('caregiver.CaregiverList.Filter.CaregiverName')}
        onChange={(event) => updateSearch(event.target.value)}
        sx={{
          'width': '100%',
          'minWidth': 0,
          'p': 0,
          'border': 'none',
          'outline': 'none',
          'backgroundColor': 'transparent',
          'font': 'inherit',
          'fontSize': 14,
          '&::placeholder': {
            color: '#7C7C7C',
            opacity: 1,
          },
        }}
      />
      <IconButton
        size="small"
        aria-label="Clear caregiver name search"
        onClick={clearSearch}
        sx={{p: 0, visibility: searchText ? 'visible' : 'hidden'}}
      >
        <CloseRounded sx={{fontSize: 16}} />
      </IconButton>
    </Box>
  );
};

Search.propTypes = {
  filterOptions: PropTypes.object.isRequired,
  selection: PropTypes.object.isRequired,
  updateFilter: PropTypes.func.isRequired,
};

export default React.memo(Search);
